import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {$e} from 'codelyzer/angular/styles/chars';

@Component({
  selector: 'app-slide-form-field',
  templateUrl: './slide-form-field.component.html',
  styleUrls: ['./slide-form-field.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SlideFormFieldComponent)}
  ]
})
export class SlideFormFieldComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() required = false;
  @Input() color = 'accent';
  @Input() disabled = false;

  value = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.value = value;
  }

  valueChanged($event: MatSlideToggleChange): void {
    this.onChange($event.checked);
  }
}
